    import { Fragment, useEffect, useRef, useState, useMemo, FC } from 'react';
    import { Link } from 'react-router-dom';
    import { FacebookIcon } from '@ui/icons/social/facebook';
    import { InstagramIcon } from '@ui/icons/social/instagram';
    import { YoutubeIcon } from '@ui/icons/social/youtube';
    import { LandingNavbar } from '@app/landing/landing-navbar';
    import { color, motion } from "framer-motion";
    import { Sparkles, User } from 'lucide-react';
    import { Shield, ShieldCheck, Share2, UserPlus, Upload, Globe2, FolderOpen, SlidersHorizontal, Layers,FolderKanban, Rocket  } from "lucide-react";
    import {  Lock, Database, FileX , Users, Eye,  Globe , Zap , CloudCheck , LayoutDashboard ,Cpu,FolderX ,ShieldOff, Key  } from 'lucide-react';
    import {  MonitorSmartphone , FileWarning  , Target , Smile , Gauge , Briefcase,  } from 'lucide-react';
    import { BillingCycleRadio } from '@common/billing/pricing-table/billing-cycle-radio';
    import { PricingTable } from '@common/billing/pricing-table/pricing-table';
    import {
      ContactPagePayload,
      useSubmitContactForm,
    } from '@common/contact/use-submit-contact-form';
    import { useForm } from 'react-hook-form';
    import { Dialog } from '@ui/overlays/dialog/dialog';
    import { DialogBody } from '@ui/overlays/dialog/dialog-body';
    import { DialogHeader } from '@ui/overlays/dialog/dialog-header';
    import { DialogTrigger } from '@ui/overlays/dialog/dialog-trigger';
    import { FormTextField } from '@ui/forms/input-field/text-field/text-field';
    import { useRecaptcha } from '@common/recaptcha/use-recaptcha';
    import { Button } from '@ui/buttons/button';
    import { Trans } from '@ui/i18n/trans';
    import { Form } from '@ui/forms/form';
    import { UpsellBillingCycle } from '@common/billing/pricing-table/find-best-price';
    import { useProducts } from '@common/billing/pricing-table/use-products';
    import { CheckCircleOutlineIcon } from '@ui/icons/material/CheckCircleOutline';
    import { FullPageLoader } from '@ui/progress/full-page-loader';
    import { LucideIcon } from "lucide-react";
    import { useThemeSelector } from '@ui/themes/theme-selector-context';
    import { Helmet } from "@common/seo/helmet";
    import {
    ShieldAlert,
    Smartphone,
    IndianRupee,
    RefreshCw, HardDrive,
    } from "lucide-react";

    export function DropboxAlternative() {
      const query = useProducts('pricingPage');
        const [selectedCycle, setSelectedCycle] =
          useState<UpsellBillingCycle>('month');
    
        const { selectThemeTemporarily } = useThemeSelector();
      useEffect(() => {
        selectThemeTemporarily('light');
        return () => selectThemeTemporarily(null);
      }, [selectThemeTemporarily]);
    
     const steps = [
        {
          icon: UserPlus,
          number: '01',
          title: 'Sign Up',
          description: 'Create your account in seconds with no credit card required',
        },
        {
          icon: Upload,
          number: '02',
          title: 'Upload Files',
          description: 'Upload files or sync folders instantly with secure, high-speed cloud storage',
        },
        {
          icon: Globe2,
          number: '03',
          title: 'Access Anywhere',
          description: 'Access your data from any device, anywhere in the world',
        },
      ];
    
      

      const [openIndex, setOpenIndex] = useState<number | null>(0);
    
      const toggle = (index: number) => {
        setOpenIndex(openIndex === index ? null : index);
      };
    
      const faqData = [
          {
            question: "SpaceByte vs Google Drive vs Dropbox: Which is best?",
            answer: "In the debate of <strong>SpaceByte vs Google Drive vs Dropbox</strong>, SpaceByte wins for B2B privacy. While legacy <strong>cloud hosting</strong> providers charge in USD and scrape data for AI, SpaceByte offers a strict zero-knowledge policy and sub-15ms local latency.",
          },
          {
            question: "Dropbox problems and how SpaceByte solves them?",
            answer:
                "Honestly, Dropbox issues like limited free storage, syncing delays, file conflicts, and device limits can slow things down. SpaceByte cloud storage solves these problems with more free storage, faster uploads, no file size limits, and smoother syncing.",
          },
          {
            question: "Which cloud storage is better for large files?",
            answer:
              "From what I've seen, storage without file size limits just works better. SpaceByte cloud storage lets you upload and download large files easily, so you’re not stuck compressing or splitting them every time.",
          },
          {
            question: "Can I use cloud storage on multiple devices easily?",
            answer:
              "With Dropbox, the free plan limits device connections, which can feel a bit annoying if you switch devices often. SpaceByte secure cloud storage is more flexible, so you can access your files across devices without worrying about limits.",
          },
          {
            question: "Is cloud storage safe for personal files?",
            answer:
              "Dropbox does have solid security like encryption, so it's generally safe. Still, many people lean toward secure and flexible cloud storage like SpaceByte, with end-to-end encryption and better control over file access and privacy.",
          },
          {
            question: "Are there robust cloud storage alternatives to dropbox?",
            answer:
              "Absolutely. If you are looking for a <strong>cloud storage like dropbox</strong> but need faster local speeds in India and larger quotas, SpaceByte is consistently rated as <strong>better cloud storage than dropbox</strong>. When comparing zero-knowledge privacy, SpaceByte is significantly <strong>better than dropbox for cloud storage</strong>.",
          }
        ];
      
        const [activeIndex, setActiveIndex] = useState<number>(0);
        const [visible, setVisible] = useState(false);
        const ref = useRef<HTMLDivElement | null>(null);
  
        
          useEffect(() => {
            const obs = new IntersectionObserver(
              ([e]) => {
                if (e.isIntersecting) setVisible(true);
              },
              { threshold: 0.12 }
            );
        
            if (ref.current) obs.observe(ref.current);
            return () => obs.disconnect();
          }, []);
        
          const [active, setActive] = useState("light");
    
            const trackRef = useRef<HTMLDivElement | null>(null);
            const [paused, setPaused] = useState(false);
          
    
        // const items = [...items, ...items];
          
            useEffect(() => {
              const track = trackRef.current;
              if (!track) return;
          
              let raf = 0;
              let x = 0;
          
              const speed = 0.65;
          
              const animate = () => {
                if (!paused) {
                  x -= speed;
          
                  const halfWidth = track.scrollWidth / 2;
                  if (Math.abs(x) >= halfWidth) x = 0;
          
                  track.style.transform = `translateX(${x}px)`;
                }
          
                raf = requestAnimationFrame(animate);
              };
          
              raf = requestAnimationFrame(animate);
          
              return () => cancelAnimationFrame(raf);
            }, [paused]);
    
         
      const [hoveredId, setHoveredId] = useState<string | null>(null);
      
      const features: {
          icon: LucideIcon;
          title: string;
          text: string;
        }[] = [
        {
          icon: Gauge,
          title: "Speed & Performance",
          text: "You notice the speed difference quickly. SpaceByte cloud storage feels fast and responsive with larger uploads and no bandwidth limits, while Proton Drive can feel slower during syncing.",
        },
        {
          icon: FolderOpen,
          title: "Large File Handling",
          text: "Working with large files feels easier with unlimited online cloud storage. Uploads stay smooth with no file size limits, while Proton Drive can take more time.",
        },
        {
          icon: Share2,
          title: "Easy File Sharing",
          text: "Sharing files becomes simple with cloud storage. You can send secure links, share files through email, and manage access easily, while Proton Drive’s file sharing feels more basic.",
        },
        {
          icon: Users,
          title: "Better Collaboration",
          text: "For teamwork, cloud storage feels more practical. Sharing files and managing access is simple, while Proton Drive is more for personal use with limited collaboration options.",
        },
        {
          icon: Database,
          title: "Flexible Storage Options",
          text: "Scalable cloud storage gives you flexibility as your needs grow, so you don't feel restricted, while Proton Drive can start feeling limited over time with regular uploads.",
        },
        {
          icon: Smile ,
          title: "User Experience",
          text: "Overall, cloud storage feels smooth and easy to use, with a user-friendly interface and simple navigation, while Proton Drive can feel too minimal and not fully complete.",
        },
      ];

      interface Feature {
        id: string;
        number: string;
        title: string;
      }

      const Features: Feature[] = [
        {
          id: " ",
          number: "01",
          title: "Fast, stable uploads without repeated retries.",
        },
        {
          id: " ",
          number: "02",
          title: "Enough free storage to avoid quick limits.",
        },
        {
          id: " ",
          number: "03",
          title: "Smooth syncing across all your devices.",
        },
        {
          id: " ",
          number: "04",
          title: "Easy file sharing with clear access control.",          
        },
        {
          id: " ",
          number: "05",
          title: "End-to-end encryption for better data safety.",          
        },
        {
          id: " ",
          number: "06",
          title: "Upload large files without size limits.",          
        },
        {
          id: " ",
          number: "07",
          title: "Simple, clean interface for daily use.",          
        },
      ];

      const styles: Record<string, React.CSSProperties> = {
        header: {
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          gap: "2rem",
          marginBottom: "2.5rem",
          flexWrap: "wrap",
        },
        headerLeft: {
          flex: 1,
          minWidth: "260px",
        },
        headline: {
          fontSize: "clamp(26px, 4vw, 36px)",
          fontWeight: 700,
          color: "#0D1B3E",
          lineHeight: 1.2,
          margin: "0 0 12px",
        },
        subtext: {
          fontSize: "14px",
          color: "#6B7A99",
          lineHeight: 1.7,
          maxWidth: "400px",
          margin: 0,
        },
        headerRight: {
          flexShrink: 0,
        },
        scoreCard: {
          background: "#fff",
          border: "1px solid #E8ECF4",
          borderRadius: "16px",
          padding: "16px 20px",
          display: "flex",
          alignItems: "center",
          gap: "16px",
          minWidth: "220px",
        },
        scoreItem: {
          display: "flex",
          alignItems: "center",
          gap: "10px",
          flex: 1,
        },
        scoreBadge: {
          width: "38px",
          height: "38px",
          borderRadius: "10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "12px",
          fontWeight: 700,
          flexShrink: 0,
        },
        scoreName: {
          fontSize: "11px",
          color: "#9BA8C0",
          fontWeight: 500,
          marginBottom: "2px",
        },
        scoreDivider: {
          width: "1px",
          height: "36px",
          background: "#EEF0F4",
          flexShrink: 0,
        },
        colHeaders: {
          display: "grid",
          gridTemplateColumns: "200px 1fr 1fr",
          gap: "0 12px",
          marginBottom: "4px",
          paddingBottom: "10px",
          borderBottom: "2px solid #E8ECF4",
        },
        colFeature: {},
        colHeader: {
          fontSize: "18px",
          fontWeight: 600,
          color: "#9BA8C0",
          padding: "0 16px",
          display: "flex",
          alignItems: "center",
          gap: "7px",
        },
        colHeaderActive: {
          color: "#0F5FBF",
        },
        colHeaderDot: {
          width: "7px",
          height: "7px",
          borderRadius: "50%",
          background: "#0F5FBF",
          display: "inline-block",
          flexShrink: 0,
        },
        tableBody: {
          display: "flex",
          flexDirection: "column" as const,
          background: "#fff",
          border: "1px solid #E8ECF4",
          borderRadius: "16px",
          overflow: "hidden",
          marginBottom: "1.5rem",
        },
        row: {
          display: "grid",
          gridTemplateColumns: "200px 1fr 1fr",
          gap: "0 12px",
          padding: "0",
          transition: "background 0.15s",
          cursor: "default",
        },
        rowActive: {
          background: "#F5F8FF",
        },
        featureCell: {
          display: "flex",
          alignItems: "center",
          gap: "10px",
          padding: "18px 16px",
          borderRight: "1px solid #EEF0F4",
        },
        featureIcon: {
          width: "34px",
          height: "34px",
          borderRadius: "9px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          transition: "all 0.2s",
          padding: "6px",
        },
        featureName: {
          fontSize: "13px",
          fontWeight: 600,
          lineHeight: 1.3,
          transition: "color 0.15s",
        },
        valueCell: {
          padding: "18px 16px",
          display: "flex",
          flexDirection: "column" as const,
          gap: "6px",
          borderRight: "1px solid #EEF0F4",
        },
        valueCellPrimary: {
          borderRight: "1px solid #EEF0F4",
        },
        winBadge: {
          display: "flex",
        },
        badge: {
          display: "inline-flex",
          alignItems: "center",
          gap: "4px",
          fontSize: "10px",
          fontWeight: 600,
          padding: "3px 8px",
          borderRadius: "20px",
          letterSpacing: "0.02em",
        },
        valueText: {
          fontSize: "15px",
          color: "#4A5568",
          lineHeight: 1.55,
          margin: 0,
        },
        ctaBtn: {
          fontSize: "13px",
          fontWeight: 600,
          color: "#fff",
          background: "#0F5FBF",
          border: "none",
          padding: "10px 22px",
          borderRadius: "10px",
          cursor: "pointer",
          letterSpacing: "0.01em",
          transition: "background 0.15s, transform 0.1s",
        },
      };

      const css = `
        .cs-cta-btn:hover {
          background: #0A4A99 !important;
          transform: translateY(-1px);
        }
        .cs-cta-btn:active {
          transform: scale(0.98);
        }

        @media (max-width: 640px) {
          section {
            padding: 1.5rem 1rem !important;
          }
          div[style*="gridTemplateColumns: 200px"] {
            grid-template-columns: 1fr !important;
          }
          div[style*="grid-template-columns: 200px"] {
            grid-template-columns: 1fr !important;
          }
        }
      `;

      const [activeRow, setActiveRow] = useState<number | null>(null);

      interface Row {
        feature: string;
        spacebyte: React.ReactNode;
        dropbox: string;
      }

      const rows: Row[] = [
        {
          feature: "Free Storage",
          spacebyte: "25 GB",
          dropbox: "2 GB",
        },
        {
          feature: "Performance",
          spacebyte: "Fast & smooth",
          dropbox: "Moderate",
        },
        {
          feature: "File Size Limits",
          spacebyte:"No strict limits",
          dropbox: "Restricted",
        },
        {
          feature: "Security",
          spacebyte: "End-to-End Encryption + TLS 1.3",
          dropbox: "AES-256",
        },
        {
          feature: "Device Access",
          spacebyte: "Flexible",
          dropbox: "Limited (free plan)",
        },
        {
          feature: "Pricing",
          spacebyte: "More affordable",
          dropbox: "Higher",
        },
        {
          feature: "Focus",
          spacebyte: "Secure storage & large files",
          dropbox: "Collaboration tools",
        },
      ];

      const featureIcons: Record<string, React.ReactNode> = {
        "Free Storage": <Database   />,
        "Performance": <Zap   />,
        "File Size Limits": <FileWarning   />,
        "Security": <ShieldCheck   />,
        "Device Access": <MonitorSmartphone   />,
        "Pricing": <IndianRupee   />,
        "Focus": <Target  />,
      };

      const items = [
        {
          icon: HardDrive ,
          name: "Limited Free Storage Space",
          text: "Dropbox gives only 2 GB free, and it fills up fast when you start saving photos, videos, or work files."
        },
        {
          icon: RefreshCw ,
          name: "Syncing Delays & File Conflicts",
          text: "Sometimes files don't sync on time, or duplicates appear, which honestly slows things down and gets a bit frustrating."
        },
        {
          icon: IndianRupee ,
          name: "Expensive Upgrade Plans",
          text: "You eventually need more storage, but compared to other options, Dropbox pricing can feel a little high for the space."
        },
        {
          icon: Share2,
          name: "Sharing & Permission Confusion",
          text: "Sharing files sounds easy, but mixing up view and edit access happens often, especially when working with others."
        },
        {
          icon: Smartphone ,
          name: "Device Limit Restrictions",
          text: "There's a device limit on free plans, so switching between phone, laptop, and desktop can feel a bit restrictive."
        },
        {
          icon: ShieldAlert ,
          name: "Privacy & Data Location Concerns",
          text: "Some users prefer local data storage, but with global platforms, it’s not always clear where files are actually stored."
        },
      ];
            
      // const items = [...items, ...items];
            
              useEffect(() => {
                const track = trackRef.current;
                if (!track) return;
            
                let raf = 0;
                let x = 0;
            
                const speed = 0.65;
            
                const animate = () => {
                  if (!paused) {
                    x -= speed;
            
                    const halfWidth = track.scrollWidth / 2;
                    if (Math.abs(x) >= halfWidth) x = 0;
            
                    track.style.transform = `translateX(${x}px)`;
                  }
            
                  raf = requestAnimationFrame(animate);
                };
            
                raf = requestAnimationFrame(animate);
            
                return () => cancelAnimationFrame(raf);
              }, [paused]);
      
               useStyles();
      
        const headerRef = useRef<HTMLDivElement>(null);
        const gridRef = useRef<HTMLDivElement>(null);
      
        useReveal(headerRef);
        useReveal(gridRef);

      return (
        <Fragment>
    
          <Helmet>
            <title>Best Dropbox Alternative for Secure Cloud Storage</title>
            <meta
              name="description"
              content="Looking for a better Dropbox alternative? Discover fast, secure cloud storage with more free space, smooth syncing, and easy file sharing for everyday use."
            />
            <meta name="keywords" content="Dropbox alternative, cloud storage alternative" />
            <link rel="canonical" href="https://spacebyte.in/dropbox-alternative-fast-secure-cloud-storage" />
          </Helmet>
    
          <LandingNavbar
            color="transparent"
            className="fixed top-0 z-50 w-full flex-shrink-0 border-none bg-light-primary  shadow-lg"
            menuPosition="homepage-navbar"
          />
          
          <section className=" relative overflow-hidden !bg-gradient-to-r !from-[#0072ff]/8 !to-[#00c6ff]/8 py-24 md:py-32">
            <div className="absolute inset-0 opacity-5">
              <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
                <defs>
                  <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
                    <path d="M 40 0 L 0 0 0 40" fill="none" stroke="#1E3A8A" strokeWidth="1" />
                  </pattern>
                </defs>
                <rect width="100%" height="100%" fill="url(#grid)" />
              </svg>
            </div>
            <div
              className={`landing-container z-10 flex flex-col items-center justify-between pb-40 pt-100 lg:flex-row`}
            >
              <div className="mx-auto w-full max-w-6xl px-4 text-center">
    
                {/* Heading */}
                <h1 className="font-archivo text-[40px] md:text-[60px] font-bold leading-[1.2] tracking-[-0.02em] text-[#1f2937]">
                 Dropbox Alternative for   {" "} 
                 <br />     
                 <span className="color-primary-gradient">Modern Cloud Storage </span>
                </h1>
    
                {/* Sub heading */}
                <p className="mx-auto mt-30 max-w-3xl font-inter text-[18px] md:text-[20px]  text-[#6b7280]">
                    Cloud storage is essential today, but Dropbox often feels limited over time. Many users now look for a more flexible, secure, and practical <Link to="/terabox-alternative" className="text-[#0072ff] hover:underline font-medium">cloud storage alternative</Link>.
                </p>
    
              <div className="my-36 pb-20 flex flex-col items-center justify-center gap-6 sm:flex-row">
                <a
                  href="/register"
                  className="inline-flex items-center justify-center 
                  px-26 py-10 
                  text-white font-bold
                  bg-gradient-to-r from-[#0072ff] to-[#00c6ff]
                  shadow-lg transition-all duration-300
                  hover:from-[#0059d6] hover:to-[#00aaff]
                  hover:shadow-2xl hover:-translate-y-1"
                  style={{
                  borderRadius: "12px"
                }}
                >
                  Get 25 GB FREE
                </a>
                <a
                  href="/pricing"
                  className="inline-flex items-center justify-center
                  px-36 py-8 font-bold
                  text-[#0072ff]
                  relative transition-all duration-300
                  hover:-translate-y-1 hover:shadow-lg "
                  style={{
                    borderRadius: "12px",
                    background: "linear-gradient(#e5f5fb, #e5f5fb) padding-box, linear-gradient(90deg, #0072ff, #00c6ff) border-box",
                    border: "2px solid transparent"
                  }}
                  >
                  View Pricing
                </a>
              </div>
              </div>
            </div>
          </section>  

          <section className="py-24 md:py-32 bg-gradient-to-br from-[#F8FAFC] to-white relative overflow-hidden">
            {/* Background Pattern */}
            <div className="absolute inset-0 opacity-5 landing-container z-10">
              <div className="absolute top-10 left-10 w-72 h-72 bg-[#3B82F6] rounded-full blur-3xl"></div>
              <div className="absolute bottom-10 right-10 w-96 h-96 bg-[#06B6D4] rounded-full blur-3xl"></div>
            </div>
    
            <div className="max-w-7xl mx-auto px-4 my-30 md:my-50 sm:px-6 lg:px-8 relative z-10">
              {/* Section Header */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="text-center mb-16"
              >
    
                <h2 className="text-3xl sm:text-4xl lg:text-5xl font-archivo font-bold text-[#111827] mb-10">
                  Start Your Cloud Storage in <span className="color-primary-gradient">Three Steps</span>{" "}
    
                </h2>
                <p className="text-lg text-[#6B7280] max-w-2xl mx-auto pb-10 font-archivo">
                  Start storing and sharing your files securely in minutes
                </p>
              </motion.div>
    
              {/* Steps */}
              <div className="grid md:grid-cols-3 gap-8 md:gap-12 relative landing-container">
                {/* Connecting Line */}
                <div className="hidden md:block absolute top-90 left-0 right-0 h-2 bg-gradient-to-r from-[#3B82F6] via-[#60A5FA] to-[#06B6D4] opacity-30"></div>
    
                {steps.map((step, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: index * 0.2 }}
                    className="relative"
                  >
                    <div className="flex flex-col items-center text-center">
                      {/* Icon Circle */}
                      <div className="relative mb-6">
                        <div className="w-80 h-80 bg-gradient-to-br from-[#1E3A8A] to-[#3B82F6] rounded-full flex items-center justify-center relative z-10 shadow-lg">
                          <step.icon className="w-40 h-40 text-white" />
                        </div>
                        <div className="absolute -top-2 -right-10  w-40 h-40 bg-white rounded-full flex items-center justify-center border-2 border-[#3B82F6] z-20">
                          <span className="text-[#1E3A8A] font-bold text-sm">{step.number}</span>
                        </div>
                      </div>
    
                      {/* Content */}
                      <h3 className="text-2xl font-semibold font-archivo text-[#111827] my-20">
                        {step.title}
                      </h3>
                      <p className="text-[#6B7280] font-archivo max-w-xs">
                        {step.description}
                      </p>
                    </div>
                  </motion.div>
                ))}
              </div>
    
              {/* Animated Line */}
              <motion.div
                initial={{ scaleX: 0 }}
                whileInView={{ scaleX: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 1.5, delay: 0.5 }}
                className=" hidden md:block absolute top-[260px] left-[25%] right-[25%] h-3 bg-gradient-to-r from-[#3B82F6] to-[#06B6D4] rounded-full origin-left"
              ></motion.div>
            </div>
          </section>

          <section className="bg-[#f5f8ff] py-30 md:py-50 relative overflow-hidden">
            <div className="landing-container z-10">

            {/* Heading */}
            <div className="text-center space-y-8">
            <h3 className="font-archivo text-3xl font-bold md:text-4xl lg:text-5xl text-[#1f2937]">
                Why Users Are <span className="color-primary-gradient"> Moving Beyond Dropbox</span>
            </h3>
            <p className="font-inter text-sm md:text-base color-gray mt-10">
                Dropbox works well, but today's users need more than basic file storage. As daily work increases, its limitations start becoming noticeable in regular use.
            </p>
            </div>

            {/* Marquee */}
            <div className="relative mt-30 overflow-hidden">

            <div
                onMouseEnter={() => setPaused(true)}
                onMouseLeave={() => setPaused(false)}
                className="w-full"
            >
                <div
                ref={trackRef}
                className="flex items-center gap-20 my-10 will-change-transform"
                style={{ transform: "translateX(0px)" }}
                >

                {items.map((item, index) => (
                    <div
                    key={index}
                    className="min-w-[300px] rounded-2xl border bg-[#e3eaf9] p-20 shadow-sm transition-all duration-300 hover:-translate-y-2 hover:shadow-xl"
                    >
                    <div className="flex items-center gap-10 mb-12 ">
                        <div className="w-50 h-50 flex items-center justify-center rounded-xl bg-[#0072ff]/10">
                        <item.icon size={28} className="text-[#1E3A8A]" />
                        </div>
                        <div>
                        <h4 className="font-semibold  text-[#1E3A8A]">
                            {item.name}
                        </h4>
                        {/* <p className="text-sm text-gray-500">
                            {item.role}
                        </p> */}
                        </div>
                    </div>

                    <p className="text-[#6B7280] text-sm leading-relaxed">
                        {item.text}
                    </p>
                    </div>
                ))}

                </div>
            </div>

            {/* Fade edges */}
            <div className="pointer-events-none absolute left-0 top-0 h-full w-80 bg-gradient-to-r from-white to-transparent" />
            <div className="pointer-events-none absolute right-0 top-0 h-full w-80 bg-gradient-to-l from-white to-transparent" />
            </div>
            </div>
          </section>

          <section
        id="Pricing"
        className="pricing-section relative overflow-hidden bg-white py-40 text-black lg:py-50"
      >
        <div className="landing-container z-10">
          <div className="mx-auto max-w-xl space-y-16 text-center">
            <h2 className="animate-fade-down font-archivo text-3xl font-bold md:text-4xl lg:text-5xl">
              Affordable <span className="color-primary-gradient"> Cloud Storage Pricing </span> Plans
            </h2>
            <p className="color-gray font-inter animate-fade-down">
              Get affordable pricing with no hidden fees, encrypted cloud storage,
              and fast, seamless access to your files anytime, anywhere.
            </p>
          </div>

          <div className="my-40 flex flex-col md:flex-row justify-center items-center gap-16">
            <BillingCycleRadio
              products={query.data?.products}
              selectedCycle={selectedCycle}
              onChange={setSelectedCycle}
              className="input-radio animate-fade-up flex justify-center items-center flex-wrap"
              size="lg"
            />
          </div>

          <PricingTable
            selectedCycle={selectedCycle}
            productLoader="pricingPage"
            className="animate-fade-down"
          />

          {/* Premium Section */}
          <div
            className="premium-bg animate-fade-down bg-light-primary relative mt-40 flex flex-col items-center justify-between space-y-8 overflow-hidden rounded-2xl border-primary p-16 shadow-lg md:flex-row md:space-y-0 md:p-32"
            style={{
              backgroundImage:
                "url('/images/LandingImg/ctamask.png'), url('/images/LandingImg/ctashape.png')",
              backgroundSize: 'contain, contain',
              backgroundRepeat: 'no-repeat, no-repeat',
              backgroundPosition: 'left center, right center',
            }}
          >
            {/* Premium Tag */}
            <div className="font-archivo absolute -left-54 top-16 w-160 rotate-[-45deg] transform rounded bg-warning text-center text-sm font-medium text-black md:-left-56 lg:-left-50 lg:top-20">
              Premium
            </div>

            {/* Icon and Text */}
            <div className="flex flex-col items-center gap-8 space-y-8 md:flex-row md:space-x-8 md:space-y-0">
              <img
                src="/images/LandingImg/cta-icon.webp"
                className="color-primary rounded-lg bg-white p-16"
              />
              <div className="text-center md:text-left">
                <h2 className="font-archivo text-3xl font-bold">
                  5 TB or More?
                </h2>
                <span className="color-primary font-archivo text-2xl font-semibold">
                  ₹0.15/GB{' '}
                  <span className="text-lg font-normal text-black">
                    /Monthly
                  </span>
                </span>
                <p className="font-inter mt-8 flex items-start justify-center gap-4 text-sm md:justify-start">
                  <CheckCircleOutlineIcon size="sm" /> 100% Safe & Secure with
                  End-to-End Encryption
                </p>
                <p className="font-inter mt-1 flex items-start justify-center gap-4 text-sm md:justify-start">
                  <CheckCircleOutlineIcon size="sm" /> Calculate the cost or
                  Reach out to us
                </p>
              </div>
            </div>

            {/* Buttons */}
            <div className="flex flex-row flex-wrap gap-8 sm:flex-col lg:flex-row justify-center">
              <div className="flex justify-center">
                {CalculateDialogTrigger()}
              </div>

              <div className="mt-0 flex justify-center">
                <a href="/contact" className="btn bg-[#f9fafb] border-2 border-[#0072ff] text-black hover:bg-[#0072ff] hover:text-white">
                  <span>Contact Us</span>
                </a>
              </div>
            </div>
          </div>
        </div>
          </section>

          <section className="w-full bg-[#f5f8ff] py-30 md:py-50 px-6 md:px-16 relative overflow-hidden">
            <div className="landing-container z-10">
            <style>{`
              .cs-divider {
                height: 0.5px;
                background: #e0e0e0;
                margin-bottom: 0;
              }
              .cs-item {
                display: grid;
                grid-template-columns: 48px 1fr auto;
                align-items: center;
                gap: 0 1.25rem;
                padding: 1.1rem 0;
                border-bottom: 0.5px solid #ebebeb;
                cursor: default;
                transition: background 0.12s;
              }
              .cs-item:last-of-type {
                border-bottom: none;
              }
              .cs-bar {
                width: 3px;
                height: 36px;
                background: #e0e0e0;
                justify-self: center;
                transition: background 0.15s;
                border-radius: 0;
              }
              .cs-bar-active {
                background: #378ADD;
              }
              .cs-mid {
                display: flex;
                flex-direction: column;
                gap: 3px;
              }
              .cs-num {
                font-size: 10px;
                font-weight: 500;
                color: #aaa;
                letter-spacing: 0.06em;
              }
              .cs-title {
                font-size: 15px;
                font-weight: 500;
                color: #1a1a1a;
                transition: color 0.15s;
              }
              .cs-title-active {
                color: #185FA5;
              }margin-top: 1px;
              }
            `}</style>

              <div className="text-center mb-14">
                <h2 className="animate-fade-down font-archivo text-3xl font-bold md:text-4xl lg:text-5xl py-16 md:py-24">
                  What <span className="color-primary-gradient"> Modern Cloud Storage </span> Should Offer 
                </h2>
                <p className="color-gray font-inter animate-fade-down mb-10">
                  A good Dropbox alternative should feel fast, reliable, and simple, making file storage and sharing easy without constant issues or frustration.
                </p>
              </div>

            <div className="cs-divider" />

            {Features.map((f) => {
              const isHovered = hoveredId === f.id;
              return (
                <div
                  key={f.id}
                  className="cs-item"
                  onMouseEnter={() => setHoveredId(f.id)}
                  onMouseLeave={() => setHoveredId(null)}
                >
                  <div className={`cs-bar ${isHovered ? "cs-bar-active" : ""}`} />
                  <div className="cs-mid">
                    <span className="cs-num">{f.number}</span>
                    <span className={`cs-title ${isHovered ? "cs-title-active" : ""}`}>
                      {f.title}
                    </span>
                  </div>
                </div>
              );
            })}
            </div>
          </section>

           <section className="w-full bg-white py-30 md:py-50 px-6 md:px-16 relative overflow-hidden">
            <div className="landing-container z-10">
            <style>{css}</style>

            {/* Header */}
            <div style={styles.header}>
              <div style={styles.headerLeft}>
                <h2 style={styles.headline}>
                  SpaceByte Cloud<br />
                  <span className="color-primary-gradient"> vs </span> Dropbox 
                </h2>
                <p style={styles.subtext}>
                  
                </p>
              </div>
              
              <div style={styles.headerRight}>
                <div style={styles.scoreCard}>
                  <div style={styles.scoreItem}>
                    <div style={{ ...styles.scoreBadge, background: "#0F5FBF", color: "#fff" }}>SB</div>
                    <div>
                      <div style={styles.scoreName}>SpaceByte</div>
                    </div>
                  </div>
                  <div style={styles.scoreDivider} />
                  <div style={styles.scoreItem}>
                    <div style={{ ...styles.scoreBadge, background: "#F0F2F5", color: "#555" }}>DB</div>
                    <div>
                      <div style={styles.scoreName}>Dropbox </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Column headers */}
            <div style={styles.colHeaders}>
              <div style={styles.colFeature} />
              <div style={{ ...styles.colHeader, ...styles.colHeaderActive }}>
                <span style={styles.colHeaderDot} />
                SpaceByte Cloud
              </div>
              <div style={styles.colHeader}>Dropbox</div>
            </div>

            {/* Rows */}
            <div style={styles.tableBody}>
              {rows.map((row, i) => {
                const isActive = activeRow === i;
                return (
                  <div
                    key={row.feature}
                    style={{
                      ...styles.row,
                      ...(isActive ? styles.rowActive : {}),
                      borderBottom: i < rows.length - 1 ? "1px solid #EEF0F4" : "none",
                    }}
                    onMouseEnter={() => setActiveRow(i)}
                    onMouseLeave={() => setActiveRow(null)}
                  >
                    {/* Feature label */}
                    <div style={styles.featureCell}>
                      <div
                        style={{
                          ...styles.featureIcon,
                          background: isActive ? "#0F5FBF" : "#F0F4FF",
                          color: isActive ? "#fff" : "#0F5FBF",
                        }}
                      >
                        {featureIcons[row.feature]}
                      </div>
                      <span style={{ ...styles.featureName, color: isActive ? "#0F5FBF" : "#1a1a2e" }}>
                        {row.feature}
                      </span>
                    </div>

                    {/* SpaceByte cell */}
                    <div style={{ ...styles.valueCell, ...styles.valueCellPrimary }}>
                      <div style={styles.winBadge}>
                      </div>
                      <p style={styles.valueText}>{row.spacebyte}</p>
                    </div>

                    {/* Dropbox cell */}
                    <div style={styles.valueCell}>
                      <div style={styles.winBadge}>
                      </div>
                      <p style={styles.valueText}>{row.dropbox}</p>
                    </div>
                  </div>
                );
              })}
            </div>
            </div>
          </section>

          <section
            className="w-full relative overflow-hidden py-30 lg:py-50"
            style={{
                background: C.paper,
            }}
            >
            <div className="landing-container z-10">
            {/* Header */}
            <div
                ref={headerRef}
                className="ben-reveal gap-6"
                style={{ marginBottom: "clamp(36px, 5vw, 64px)" }}
            >
                <div className="text-center space-y-8">
                <h3 className="font-archivo  text-3xl font-bold md:text-4xl lg:text-5xl text-[#1f2937]">
                    How SpaceByte Fixes <span className="color-primary-gradient"> Dropbox Issues </span> 
                </h3>
                {/* <p className="font-inter text-sm md:text-base color-gray mt-10">
                    SpaceByte secure cloud storage is built to support the way creators work. It helps YouTubers manage large video files, upload projects faster, keep backups safe, and collaborate easily with editors or team members.
                </p> */}
                </div>
            </div>

            {/* Grid */}
            <div
                ref={gridRef}
                className="ben-reveal grid grid-cols-1 sm:grid-cols-2"
                style={{
                gap: 2,
                background: "rgba(0,0,0,0.08)",
                }}
            >
                {BENEFITS.map((b) => (
                <BenefitCard key={b.num} {...b} />
                ))}
            </div>
            </div>
          </section>

          <section className="w-full px-4 md:px-10 py-40 bg-white relative overflow-hidden">
            <div className="landing-container min-h-[280px] md:min-h-[380px] flex items-center justify-center relative rounded-2xl overflow-hidden">
    
              {/* Video Background */}
              <video
                className="absolute inset-0 w-full h-full object-cover"
                src="/images/LandingImg/video.mp4"
                autoPlay
                loop
                muted
                playsInline
              />
    
              {/* Dark Overlay */}
              <div className="absolute inset-0 bg-black/60" />
    
              {/* Gradient Light */}
              <div className="absolute inset-0 bg-gradient-to-r from-cyan-500/20 via-transparent to-blue-600/20" />
    
              {/* Content */}
              <div className="relative z-10 text-center max-w-4xl px-4">
                <h2 className="text-white text-3xl md:text-5xl font-semibold">
                  Your Data, Your Control, Your Cloud
                </h2>
    
                <p className="text-white/80 text-base md:text-lg mt-20">
                  A smarter cloud storage platform that gives you complete control over your data, file sharing, and digital privacy.
    
                </p>
    
                <div className="mt-20">
                  <a href="/contact" className="btn bg-white text-black px-20 py-10 rounded-xl font-medium hover:scale-105 transition">
                    <span>Contact Us</span>
                  </a>
                </div>
              </div>
    
            </div>
          </section>
          
          <section id="faq" className="bg-[#f5f8ff] relative overflow-hidden py-24 text-black lg:py-32">
            <div className="landing-container z-10">
              <div className="section-wrapper">
                <div className="section-inner">
                  {/* LEFT PANEL */}
                  <div className="left-panel">
                    <div className="badge font-archivo">
                      <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                        <circle cx="5" cy="5" r="5" fill="#38bdf8" />
                      </svg>
                      SpaceByte Cloud
                    </div>
    
                    <h2 className="left-title font-archivo">
                      Best Cloud Storage <br />
                      Secure, Fast and  <br />
                      Reliable
                    </h2>
    
                    <p className="left-sub font-archivo">
                      Everything you need to store, share, and access your files anytime, anywhere.
                    </p>
    
                    <div className="illustration">
                      <div className="illus-card">
                        <div className="illus-row">
                          <div className="illus-icon ic-blue">☁️</div>
                          <div className="illus-text font-archivo">
                            <strong>My Storage</strong>
                            <span>18.3 GB used of 25 GB</span>
                            <div className="illus-bar">
                              <div className="illus-bar-fill" style={{ width: "73%" }} />
                            </div>
                          </div>
                        </div>
    
                        <div className="illus-row">
                          <div className="illus-icon ic-sky">📁</div>
                          <div className="illus-text font-archivo">
                            <strong>Shared Folders</strong>
                            <span>12 folders · 3 collaborators</span>
                          </div>
                        </div>
    
                        <div className="illus-row">
                          <div className="illus-icon ic-white">🔒</div>
                          <div className="illus-text">
                            <strong>End-to-End Encrypted</strong>
                            <span>All files secured in transit</span>
                          </div>
                        </div>
    
                        <div className="stats-row">
                          <div className="stat-chip">
                            <strong>25 GB</strong>
                            <span>Free Storage</span>
                          </div>
                          <div className="stat-chip">
                            <strong>99.9%</strong>
                            <span>Uptime</span>
                          </div>
                          <div className="stat-chip">
                            <strong>24/7</strong>
                            <span>Support</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
    
                  {/* RIGHT PANEL */}
                  <div className="right-panel">
                    <p className="section-tag">Help Center</p>
    
                    <h2 className="section-title">
                      Quick Reference <br />
                      Guide
                    </h2>
    
                    <p className="section-desc">
                      Find answers to the most common questions about SpaceByte Cloud Storage.
                    </p>
    
                    <div className="accordion">
                      {faqData.map((item, index) => (
                        <div
                          key={index}
                          className={`acc-item ${openIndex === index ? "open" : ""}`}
                        >
                          <button className="acc-header" onClick={() => toggle(index)}>
                            <div className="acc-num">
                              {String(index + 1).padStart(2, "0")}
                            </div>
    
                            <span className="acc-label">{item.question}</span>
    
                            <div className="acc-chevron">
                              <svg viewBox="0 0 24 24" fill="none">
                                <polyline points="6 9 12 15 18 9" />
                              </svg>
                            </div>
                          </button>
    
                          <div className="acc-body">
                            <div
                              className="acc-body-inner"
                              dangerouslySetInnerHTML={{ __html: item.answer }}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
    
          <section className="py-20 md:py-32 bg-gradient-to-br from-[#1E3A8A] via-[#3B82F6] to-[#60A5FA] relative overflow-hidden">
            {/* Animated Background */}
            <div className="absolute inset-0 landing-container z-10">
              <div className="absolute top-0 left-0 w-96 h-96 bg-white/10 rounded-full blur-3xl animate-pulse"></div>
              <div className="absolute bottom-0 right-0 w-96 h-96 bg-white/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
            </div>
    
            {/* Grid Pattern */}
            <div className="absolute inset-0 opacity-10">
              <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
                <defs>
                  <pattern id="cta-grid" width="40" height="40" patternUnits="userSpaceOnUse">
                    <path d="M 40 0 L 0 0 0 40" fill="none" stroke="white" strokeWidth="1" />
                  </pattern>
                </defs>
                <rect width="100%" height="100%" fill="url(#cta-grid)" />
              </svg>
            </div>
    
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-40 relative z-10">
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="text-center"
              >
                {/* Icon */}
                <motion.div
                  initial={{ scale: 0 }}
                  whileInView={{ scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ type: 'spring', delay: 0.2 }}
                  className="inline-flex items-center justify-center w-60 h-60 bg-white/20 backdrop-blur-sm rounded-2xl mb-12"
                >
                  <Sparkles className="w-30 h-30 text-white" />
                </motion.div>
    
                {/* Heading */}
                <motion.h2
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.3 }}
                  className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-white"
                >
                  Ready to Secure Your Data?
                </motion.h2>
    
                {/* Subheading */}
                <motion.p
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.4 }}
                  className="text-lg sm:text-xl text-white/90 my-16 max-w-2xl mx-auto"
                >
                  Join thousands of businesses trusting secure cloud storage to protect critical data.
    
                </motion.p>
    
                {/* CTA Button */}
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.5 }}
                  className="flex flex-col sm:flex-row gap-10 justify-center items-center"
                >
                  <a href="/register" className="group bg-white text-[#1E3A8A] px-16 py-14 rounded-xl font-semibold hover:bg-gray-100 transition-all hover:shadow-2xl hover:shadow-white/20 transform hover:-translate-y-1 flex items-center gap-2 btn">
                    Get 25 GB FREE - No Card Needed
                  </a>
    
                </motion.div>
    
                {/* Trust Badges */}
                <motion.div
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.6 }}
                  className="mt-20 flex flex-wrap justify-center items-center gap-8 text-white/80 text-sm"
                >
    
                </motion.div>
              </motion.div>
            </div>
          </section>
    
          <footer className="Footer-section relative overflow-hidden bg-[#0F172A] text-white pt-16 pb-8">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              {/* Main Footer Content */}
              <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-8 mb-12">
                {/* Brand Column */}
                <div className="col-span-2 md:col-span-4 lg:col-span-2">
                  <div className="space-y-4 mr-12 padding-logo padding-top">
                    <a href="https://spacebyte.in/" className="flex-shrink-0" aria-label="SpaceByte Homepage">
                      <img
                        src="/images/logo-light.png"
                        alt="Logo"
                        className="site-logo"
                      />
                    </a>
                    <div>
                      <p className="font-medium pt-8 pb-10">SPACEBYTE CLOUD STORAGE</p>
                      <p className="pb-10 pt-3 flex items-center gap-2">
                        311, Maruti Plaza, Sardar Patel Chowk, Krishnanagar, Ahmedabad, Gujarat,
                        India - 382345</p>
                  <p className="pb-10 pt-3 flex items-center gap-2">
                    Mo. +91 97257 71457
                  </p>
                    </div>
                    <div>
                      <p className="font-bold text-base pb-10 pt-3">FOLLOW US FOR 'SPACEBYTE.IN'</p>
                      <div className="flex gap-4 mt-3 logg mb-10">
                        <ul className="flex space-x-16 pt-3 pr-10">
                          <li className="bg-light rounded-lg p-8">
                            <a href="https://www.facebook.com/profile.php?id=61567307277313&mibextid=ZbWKwL">
                              <FacebookIcon className="text-white" />
                            </a>
                          </li>
                          <li className="bg-light rounded-lg p-8">
                            <a href="https://www.instagram.com/spacebyte.in?igsh=MmZidnprMXZtbTho " aria-label="SpaceByte Instagram Profile">
                              <InstagramIcon className="text-white" />
                            </a>
                          </li>
                          <li className="bg-light rounded-lg p-8">
                            <a href="https://youtube.com/@spacebytecloudstorage?si=lt2mfOM7kSaN3g6B" aria-label="SpaceByte YouTube Channel">
                              <YoutubeIcon className="text-white" />
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
    
                {/* Product Column */}
                <div className='py-8 md:py-20 px-30'>
                  <h2 className="font-semibold text-xl mb-10  text-start ">Product</h2>
                  <ul className="space-y-3 text-sm text-gray-400 text-start">
                    <li>
                      <a href="#features" className="hover:text-white transition-colors text-start">
                        Features
                      </a>
                    </li>
                    <li>
                      <a href="/Pricing" className="hover:text-white transition-colors">
                        Pricing
                      </a>
                    </li>
                    <li>
                      <a href="#security" className="hover:text-white transition-colors">
                        Security
                      </a>
                    </li>
                    <li>
                    </li>
                  </ul>
                </div>
    
                {/* Company Column */}
                <div className='py-8 md:py-20 px-30'>
                  <h2 className="font-semibold text-xl mb-10  text-start">Company</h2>
                  <ul className="space-y-3 text-sm text-gray-400 text-start">
                    <li>
                      <a href="/about-us" className="hover:text-white transition-colors">
                        About Us
                      </a>
                    </li>
                    <li>
                      <a href="/pages/articles" className="hover:text-white transition-colors">
                        Articles
                      </a>
                    </li>
                    <li>
                      <a href="/contact" className="hover:text-white transition-colors">
                        Contact Us
                      </a>
                    </li>
                  </ul>
                </div>
    
                {/* Resources Column */}
                <div className='py-8 md:py-20 px-30'>
                  <h2 className="font-semibold text-xl mb-10  text-start">Resources</h2>
                  <ul className="space-y-3 text-sm text-gray-400 text-start">
                    <li>
                      <a href="#faq" className="hover:text-white transition-colors">
                        FAQs
                      </a>
                    </li>
                    <li>
                      <a href="/contact" className="hover:text-white transition-colors">
                        Help Center
                      </a>
                    </li>
                    {/* <li>
                    <a href="https://spacebyte.in/api-docs" className="hover:text-white transition-colors">
                      Developers
                    </a>
                  </li> */}
                <li>
                  <a href="/storage/sitemaps/sitemap-index.xml" className="hover:text-white transition-colors">
                    Sitemap
                  </a>
                </li>
                  </ul>
                </div>
    
                {/* Legal Column */}
                <div className='py-8 md:py-20 px-30'>
                  <h3 className="font-semibold text-xl mb-10  text-start">Legal</h3>
                  <ul className="space-y-3 text-sm text-gray-400 text-start">
                    <li>
                      <a href="/pages/privacy-policy" className="hover:text-white transition-colors">
                        Privacy Policy
                      </a>
                    </li>
                    <li>
                      <a href="/pages/terms-of-service" className="hover:text-white transition-colors">
                        Terms of Service
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
    
              {/* Bottom Bar */}
              <div className="font-inter border-t border-t-primary/80 py-16 text-center mt-5">
                <p className="text-sm">
                  Copyright © {new Date().getFullYear()}{' '}
                  <a href="/login" className="color-primary-gradient">
                    SpaceByte Cloud Storage
                  </a>
                  , All Rights Reserved
                </p>
              </div>
            </div>
          </footer>
        </Fragment>
      );
    }
    
    function CalculateDialogTrigger() {
      const form = useForm<ContactPagePayload>({
        defaultValues: {
          message: '', // Initialize message field
        },
      });
      const [isOpen, setIsOpen] = useState(false);
      const [isContactDialogOpen, setIsContactDialogOpen] = useState(false);
      const submitForm = useSubmitContactForm(form);
      const { verify, isVerifying } = useRecaptcha('contact');
    
      return (
        <>
          <DialogTrigger type="modal" isOpen={isOpen} onOpenChange={setIsOpen}>
            <button className="btn w-full rounded-lg !text-white font-semibold
                            !bg-gradient-to-r !from-[#0072ff] !to-[#00c6ff]  shadow-lg
                            hover:shadow-xl transition">
              <span>Get Quote</span>
            </button>
            <Dialog className="w-full max-w-lg rounded-xl p-6">
              <DialogHeader
                className="font-archivo text-2xl font-semibold"
                showDivider
              >
                <Trans message="Storage Cost Calculator" />
              </DialogHeader>
              <DialogBody>
                <div className="font-inter flex items-center justify-center">
                  Enter the storage size (whole number greater than **5 TB**) to
                  calculate your monthly cost.
                </div>
                <Form
                  form={form}
                  className="mt-4 flex flex-col items-center text-center"
                  onSubmit={async value => {
                    calculateCost(value);
                  }}
                >
                  <FormTextField
                    label={<Trans message="Enter Storage in TB" />}
                    name="tb"
                    required
                    type="number"
                    className="mb-6 w-full rounded-lg p-2"
                  />
                  <div className="text-red-500 text-md" id="errorMsg"></div>
                  <div className="text-blue-500 text-md" id="resultOutput"></div>
                  <div className="mt-6 flex w-full justify-between gap-4">
                    <button className="btn-warning mt-16" type="submit">
                      Calculate
                    </button>
                    <Button
                      color="positive"
                      variant="outline"
                      className="mt-16 rounded-lg"
                      type="button"
                      onClick={() => {
                        const resultOutput =
                          document.getElementById('resultOutput')?.textContent;
                        form.setValue('message', resultOutput || ''); // Set the value of message field
                        setIsOpen(false); // Close current dialog
                        setIsContactDialogOpen(true); // Open Contact Us dialog
                      }}
                    >
                      Contact Us
                    </Button>
                  </div>
                </Form>
              </DialogBody>
            </Dialog>
          </DialogTrigger>
    
          {isContactDialogOpen && (
            <DialogTrigger
              type="modal"
              isOpen={isContactDialogOpen}
              onOpenChange={setIsContactDialogOpen}
            >
              <Dialog className="w-full max-w-lg rounded-xl p-6">
                <DialogHeader
                  className="font-archivo text-2xl font-semibold"
                  showDivider
                >
                  <Trans message="Contact Us" />
                </DialogHeader>
                <DialogBody>
                  {submitForm.isPending ? (
                    <FullPageLoader />
                  ) : (
                    <Form
                      form={form}
                      className="flex flex-col gap-4"
                      onSubmit={async value => {
                        const isValid = await verify();
                        if (isValid) {
                          submitForm.mutate(value, {
                            onSuccess: () => {
                              setIsContactDialogOpen(false); // Close the dialog on success
                            },
                          });
                        }
                      }}
                    >
                      <FormTextField
                        label={<Trans message="Name" />}
                        name="name"
                        required
                        className="rounded-lg p-2"
                      />
                      <FormTextField
                        label={<Trans message="Email" />}
                        name="email"
                        required
                        type="email"
                        className="rounded-lg p-2"
                      />
                      <FormTextField
                        label={<Trans message="Mobile Number" />}
                        name="mobileNumber"
                        required
                        type="number"
                        className="rounded-lg p-2"
                      />
                      <FormTextField
                        label={<Trans message="Message" />}
                        name="message"
                        required
                        inputElementType="textarea"
                        className="rounded-lg p-2"
                        rows={5}
                      />
    
                      <div className="mt-4 flex w-full justify-between gap-4">
                        <Button
                          variant="flat"
                          onClick={() => setIsContactDialogOpen(false)}
                          className="rounded-lg px-4 py-2 text-lg"
                        >
                          <Trans message="Back" />
                        </Button>
                        <Button
                          type="submit"
                          variant="flat"
                          color="primary"
                          className="rounded-lg px-4 py-2 text-lg"
                        >
                          <Trans message="Send Message" />
                        </Button>
                      </div>
                    </Form>
                  )}
                </DialogBody>
              </Dialog>
            </DialogTrigger>
          )}
        </>
      );
    }
    
    function calculateCost({ tb }: any) {
      const tbInput: any = tb;
      const errorMsg: any = document.getElementById('errorMsg');
      const resultOutput: any = document.getElementById('resultOutput');
    
      // Reset messages
      errorMsg.textContent = '';
      resultOutput.textContent = '';
    
      // Validation: Ensure input is a positive integer and greater than 5
      if (!/^\d+$/.test(tbInput)) {
        errorMsg.textContent = 'Error: Storage must be a whole number!';
        return;
      }
    
      const tbValue = parseInt(tbInput, 10);
    
      if (tbValue <= 5) {
        errorMsg.textContent = 'Error: Storage must be greater than 5 TB!';
        return;
      }
    
      // Conversion and cost calculation
      const gbStorage = tbValue * 1024; // Convert TB to GB
      const cost = gbStorage * 0.15; // Calculate cost
    
      // Display result
      resultOutput.innerHTML = `
          Storage: <strong>${tbValue.toLocaleString()} TB</strong><br>
          Total Cost: <strong>₹${cost.toFixed(2)}/month</strong><br>
          GST and Convenience Fee Extra**
      `;
    }
    
    function ReviewCard({
      item,
      isActive,
    }: {
      item: any;
      isActive: boolean;
    }) {
      const { name, role, avatar, review, accent, light, rating } = item;
      
      // Extract the first letter of the name
      const initial = name?.charAt(0).toUpperCase() || "U";
    
      return (
        <div
          className={[
            "relative flex-shrink-0 overflow-hidden m-10 rounded-[28px] border-[1.5px] p-[clamp(24px,3.5vw,42px)] transition-all duration-500 flex flex-col justify-between",
            isActive ? "translate-y-[-4px] scale-[1.015]" : "scale-[0.97]",
          ].join(" ")}
          style={{
            minWidth: "clamp(270px, 42vw, 450px)",
            maxWidth: "clamp(270px, 42vw, 450px)",
            background: isActive
              ? `linear-gradient(150deg, ${light} 0%, white 100%)`
              : `linear-gradient(150deg, ${light}88 0%, #f8fafc 100%)`,
            borderColor: isActive ? `${accent}50` : "#e2e8f0",
            boxShadow: isActive
              ? `0 24px 60px ${accent}1a, 0 4px 16px ${accent}10`
              : "0 2px 12px rgba(0,0,0,0.05)",
            opacity: isActive ? 1 : 0.68,
          }}
        >
          <div>
            {/* Rating Section */}
            <div className="flex items-center justify-between mb-6">
              <div className="flex gap-1">
                {[...Array(5)].map((_, i) => (
                  <span key={i} style={{ color: i < rating ? accent : "#cbd5e1" }} className="text-[18px]">
                    ★
                  </span>
                ))}
              </div>
              {/* Subtle Quote Mark */}
              <span className="font-serif text-[60px] leading-none opacity-10 absolute right-8 top-6" style={{ color: accent }}>
                “
              </span>
            </div>
    
            <p className="font-archivo text-[clamp(14px,1.15vw,16px)] font-medium leading-[1.7] mb-8 text-[#334155]">
              "{review}"
            </p>
          </div>
    
          <div className="flex items-center gap-10">
            {/* AVATAR / INITIAL BOX */}
            <div 
              className="flex h-50 w-50 shrink-0 items-center justify-center rounded-full border-2 font-archivo text-[20px] font-bold"
              style={{ 
                borderColor: `${accent}40`,
                background: isActive ? `${accent}15` : "#f1f5f9",
                color: accent 
              }}
            >
              {avatar ? (
                <img src={avatar} alt={name} className="h-full w-full object-cover rounded-full" />
              ) : (
                <span>{initial}</span> 
              )}
            </div>
    
            <div className="overflow-hidden ">
              <h4 className="truncate font-archivo text-[17px] font-bold text-[#0f172a] leading-tight">
                {name}
              </h4>
              <p className="truncate text-[13px] font-semibold" style={{ color: accent }}>
                {role}
              </p>
            </div>
          </div>
    
          <div
            className="absolute bottom-0 left-0 h-[3px] rounded-bl-[28px] transition-all duration-[650ms] ease-[cubic-bezier(0.4,0,0.2,1)]"
            style={{
              width: isActive ? "100%" : "0%",
              background: `linear-gradient(90deg, ${accent}, ${accent}44)`,
            }}
          />
        </div>
      );
    }
    
    const C = {
      paper: "#f5f8ff",
      warm: "#beccf0", 
      ink: "#1E3A8A",
      accent: "#0072ff",
      muted: "#9a9a9b",
    } as const;
    
    const font = {
      serif: { fontFamily: "'Archivo', sans-serif" },
      mono: { fontFamily: "'Archivo', sans-serif" },
    } as const;
    
    interface Benefit {
      num: string;
      Icon: FC;
      title: string;
      text: React.ReactNode;
    }
    
    
    const BENEFITS: Benefit[] = [
      {
        num:" ",
        Icon: Zap,
        title: "Faster Uploads Without Interruptions",
        text: "Uploading large files in this cloud storage actually feels smooth and consistent. No random pauses or restart issues, which honestly saves a lot of time.",
      },
      {
        num:" ",
        Icon: Database,
        title: " More Free Storage to Start",
        text: "With 25 GB <Link to=\"/free-cloud-storage\" className=\"text-[#0072ff] hover:underline font-medium\">free cloud storage</Link>, you can actually use the platform properly before even thinking about upgrading, which is a big relief.",
      },
      {
        num:" ",
        Icon: FileX ,
        title: "No File Size Restrictions",
        text: "You don't have to compress or split files anymore. This Dropbox alternative handles large file uploads easily, which just makes things simpler.",
      },
      {
        num:" ",
        Icon: LayoutDashboard, 
        title: "Cleaner & Easier Interface",
        text: "Everything feels simple here, from uploading files to organizing folders. The interface is clean, so you’re not wasting time figuring things out.",
      },
      {
        num:" ",
        Icon: ShieldCheck,
        title: "Strong Data Security & Privacy",
        text: "With end-to-end encryption, your files stay protected. It's a secure cloud storage setup, and you get better control over file sharing too.",
      },
      {
        num:" ",
        Icon: CloudCheck,
        title: "Reliable Sync Across Devices",
        text: "Files stay updated across devices without constant login issues or sync delays. It just works in the background, which is how it should be.",
      },
    ];
    
    function useStyles(): void {
      useEffect(() => {
    
        // CSS Keyframes + Animations
        if (!document.getElementById("ben-css")) {
          const s = document.createElement("style");
          s.id = "ben-css";
          s.textContent = `
            .ben-reveal {
              opacity: 0;
              transform: translateY(28px);
              transition: opacity 0.75s ease, transform 0.75s ease;
            }
            .ben-reveal.visible {
              opacity: 1;
              transform: translateY(0);
            }
    
            .ben-card {
              position: relative;
              overflow: hidden;
              cursor: default;
            }
            .ben-card-inner {
              transition: background 0.4s ease;
            }
            .ben-card:hover .ben-card-inner {
              background: ${C.ink} !important;
            }
    
            .ben-card::after {
              content: '';
              position: absolute;
              bottom: 0; left: 0; right: 0;
              height: 2px;
              background: ${C.accent};
              transform: scaleX(0);
              transform-origin: left;
              transition: transform 0.4s ease;
            }
            .ben-card:hover::after { transform: scaleX(1); }
    
            .ben-num, .ben-title, .ben-text {
              transition: color 0.4s ease;
            }
            .ben-card:hover .ben-num { color: #1E3A8A !important; }
            .ben-card:hover .ben-title { color: ${C.paper} !important; }
            .ben-card:hover .ben-text { color: #d8d8da !important; }
    
            .ben-icon {
              width: 52px; height: 52px;
              display: flex; align-items: center; justify-content: center;
              border: 1.5px solid ${C.warm};
              background: ${C.warm};
              transition: all 0.4s ease;
            }
            .ben-icon svg { stroke: ${C.ink}; transition: stroke 0.4s ease; }
            .ben-card:hover .ben-icon {
              background: ${C.accent} !important;
              border-color: ${C.accent} !important;
            }
            .ben-card:hover .ben-icon svg { stroke: #ffffff; }
    
            .ben-card:nth-child(1) { transition-delay: 0s; }
            .ben-card:nth-child(2) { transition-delay: 0.08s; }
            .ben-card:nth-child(3) { transition-delay: 0.16s; }
            .ben-card:nth-child(4) { transition-delay: 0.24s; }
          `;
          document.head.appendChild(s);
        }
      }, []);
    }
    
    // ── Scroll Reveal Hook ────────────────────────────────────────────────────────
    function useReveal(ref: React.RefObject<HTMLElement>): void {
      useEffect(() => {
        const el = ref.current;
        if (!el) return;
    
        const obs = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              el.classList.add("visible");
              obs.disconnect();
            }
          },
          { threshold: 0.1 }
        );
        
        obs.observe(el);
        return () => obs.disconnect();
      }, [ref]);
    }
    
    // ── Benefit Card Component ────────────────────────────────────────────────────
    const BenefitCard: FC<Benefit> = ({ num, Icon, title, text }) => (
      <div className="ben-card">
        <div
          className="ben-card-inner h-full"
          style={{
            background: C.paper,
            padding: "clamp(32px, 4vw, 52px) clamp(24px, 3.5vw, 44px)",
          }}
        >
          {/* <p
            className="ben-num font-archivo"
            style={{
              fontSize: 11,
              letterSpacing: "0.2em",
              color: C.muted,
              marginBottom: 24,
            }}
          >
            {num}
          </p> */}
    
          <div className="ben-icon rounded-2xl" style={{ marginBottom: 24 }}>
            <Icon />
          </div>
    
          <h3
            className="ben-title font-archivo font text-2xl"
            style={{
              color: C.ink,
              marginBottom: 12,
            }}
          >
            {title}
          </h3>
    
          <p
            className="ben-text font-archivo"
            style={{
              fontSize: "clamp(14px, 1.2vw, 15px)",
              lineHeight: 1.8,
              color: C.muted,
              fontWeight: 300,
              maxWidth: 360,
            }}
          >
            {text}
          </p>
        </div>
      </div>
    );
    
    function WhyCard({
      item,
    }: {
      item: {
        icon: LucideIcon;
        title: string;
        text: string;
      };
    }) {
      const { icon: Icon, title, text } = item;
    
      return (
        <div
          className="
            relative overflow-hidden rounded-[16px] border
            p-[32px_28px]
            transition-all duration-500
            ease-[cubic-bezier(0.4,0,0.2,1)]
            hover:-translate-y-[6px]
            hover:shadow-[0_16px_40px_rgba(0,112,255,0.12)]
          "
          style={{
            background: "#f5f8ff",
            borderColor: "#e4edff",
    
            /* ✅ Top Gradient Line (Best Professional Way) */
            backgroundImage:
              "linear-gradient(90deg, #0070ff, #00c6ff)",
            backgroundSize: "100% 4px",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "top",
          }}
        >
          {/* Icon */}
          <div
            className="w-[50px] h-[50px] rounded-[12px] flex items-center justify-center text-[22px] mb-[18px]"
            style={{
              background: "#eaf3ff",
            }}
          >
            <Icon size={22} strokeWidth={2} className="text-[#0070ff]" />
          </div>
    
          {/* Title */}
          <h3 className="text-[16px] font-bold text-[#0d0d2b] mb-[10px]">
            {title}
          </h3>
    
          {/* Text */}
          <p className="text-[13.5px] text-[#7a8fa6] leading-[1.7]">
            {text}
          </p>
        </div>
      );
    }

    function useInView(threshold = 0.15) {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, [threshold]);
  return { ref, visible };
}
 
function MigrationArrow() {
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setProgress(p => (p >= 100 ? 0 : p + 2));
    }, 30);
    return () => clearInterval(timer);
  }, []);
  return (
    <div style={{ position: "relative", display: "flex", alignItems: "center", width: 90 }}>
      {/* Track */}
      <div style={{
        width: "100%", height: 3, background: "#e8edf5", borderRadius: 4,
        position: "relative", overflow: "hidden"
      }}>
        <div style={{
          position: "absolute", top: 0, left: 0, height: "100%",
          width: `${progress}%`, background: "linear-gradient(90deg, #3b6ef8, #5b8afe)",
          borderRadius: 4, transition: "width 0.03s linear"
        }}/>
      </div>
      {/* Arrow head */}
      <div style={{ marginLeft: 6, color: "#3b6ef8" }}>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <line x1="5" y1="12" x2="19" y2="12"/>
          <polyline points="12 5 19 12 12 19"/>
        </svg>
      </div>
    </div>
  );
}
 
function LogoBox({ children, label, sub }: { children: React.ReactNode; label: string; sub: string }) {
  return (
    <div style={{ textAlign: "center" }}>
      <div style={{
        width: 96, height: 96,
        background: "#fff",
        border: "2px dashed #d0d9f0",
        borderRadius: 22,
        display: "flex", alignItems: "center", justifyContent: "center",
        boxShadow: "0 4px 24px rgba(59,110,248,0.07)",
        margin: "0 auto 10px",
        fontSize: 42,
      }}>
        {children}
      </div>
      <div style={{ fontFamily: "'Sora', sans-serif", fontWeight: 700, fontSize: 15, color: "#1a2340" }}>{label}</div>
      <div style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 12, color: "#8a96b0", marginTop: 2 }}>{sub}</div>
    </div>
  );
}